/* reserve space for the save toast to prevent layout shift when it appears */
.toast-slot {
    margin-left: 4px;
    width: 50px;
    flex: 0 0 56px;
}
